import {
  type CompanyData,
  type TeamData,
  type TeamId,
  type TeamLevel,
  type TeamUpdateData,
  type TinyTeam,
  updateFieldWithNull,
} from '@terros/common'
import { getLevelName } from '../data'

export function getParentTeams<T extends Pick<TeamData, 'teamId' | 'parentId' | 'level'>>(
  children: T[],
  all: T[]
): T[] {
  const result: T[] = []

  function findTeams(children: T[]): void {
    children.forEach((child) => {
      if (!child.parentId) return
      all.filter((parent) => {
        if (child.parentId === parent.teamId) {
          if (child.level + 1 != parent.level) {
            console.warn('the parent team level is wrong', child.teamId)
            return
          }
          result.push(parent)
          findTeams([parent])
        }
      })
    })
  }

  findTeams(children)
  return result
}

export function getDownlineTeams<T extends Pick<TeamData, 'parentTeamIds'>>(teams: T[], teamIds: TeamId[]): T[] {
  const teamIdSet = new Set(teamIds)
  return teams.filter((team) => team.parentTeamIds.some((parentTeamId) => teamIdSet.has(parentTeamId)))
}

export function getTeamFullName(company: CompanyData | undefined, team: Pick<TeamData, 'name' | 'level'>): string {
  return `${getLevelName(company, team.level)}: ${team.name}`
}

type OfficeFields = Pick<TeamData, 'officeAddress' | 'officeLocation'>
type UpdateData<T extends TinyTeam> = Omit<Partial<T>, 'parentId' | keyof OfficeFields> &
  Pick<TeamUpdateData, 'parentId' | keyof OfficeFields>
export const partialUpdateTeamDataHelper = <T extends TinyTeam>(
  existing: T & Partial<OfficeFields>,
  data: UpdateData<T>
): T => {
  return {
    ...existing,
    ...data,
    parentId: updateFieldWithNull({ updated: data.parentId, existing: existing.parentId }),
    officeAddress: updateFieldWithNull({ updated: data.officeAddress, existing: existing.officeAddress }),
    officeLocation: updateFieldWithNull({ updated: data.officeLocation, existing: existing.officeLocation }),
  }
}

export const toLevelTeamMap = (teams: TeamData[] | undefined = []): Map<TeamLevel, TeamData[]> => {
  const map = new Map<TeamLevel, TeamData[]>()
  for (const team of teams) {
    const level = team.level
    const levelTeams = map.get(level) || []
    levelTeams.push(team)
    map.set(level, levelTeams)
  }
  return map
}
